import { useState, useEffect } from 'react';

export const CountdownTimer = ({ targetDate, targetTime }) => {
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    const calculateTimeLeft = () => {
      const target = new Date(`${targetDate}T${targetTime}:00`);
      const now = new Date();
      const difference = target - now;

      if (difference <= 0) {
        setIsExpired(true);
        return { days: 0, hours: 0, minutes: 0, seconds: 0 };
      }

      return {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / (1000 * 60)) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    };

    setTimeLeft(calculateTimeLeft());

    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate, targetTime]);

  if (isExpired) {
    return (
      <div className="flex items-center gap-2" data-testid="countdown-expired">
        <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-live-red text-white text-sm font-bold uppercase tracking-wider animate-pulse-live">
          <span className="w-2 h-2 bg-white rounded-full"></span>
          AO VIVO
        </span>
      </div>
    );
  }

  const TimeUnit = ({ value, label }) => (
    <div className="flex flex-col items-center">
      <span className="font-mono text-neon-green text-2xl md:text-4xl font-bold tabular-nums tracking-wider">
        {String(value).padStart(2, '0')}
      </span>
      <span className="text-xs text-zinc-500 uppercase tracking-widest mt-1">{label}</span>
    </div>
  );

  return (
    <div className="flex items-center gap-3 md:gap-6" data-testid="countdown-timer">
      {timeLeft.days > 0 && (
        <>
          <TimeUnit value={timeLeft.days} label="Dias" />
          <span className="text-neon-green text-2xl md:text-4xl font-bold">:</span>
        </>
      )}
      <TimeUnit value={timeLeft.hours} label="Horas" />
      <span className="text-neon-green text-2xl md:text-4xl font-bold">:</span>
      <TimeUnit value={timeLeft.minutes} label="Min" />
      <span className="text-neon-green text-2xl md:text-4xl font-bold">:</span>
      <TimeUnit value={timeLeft.seconds} label="Seg" />
    </div>
  );
};

export default CountdownTimer;
